/**
 * Form field `type` for `POST /api/thread/{threadId}/upload-file` (multipart).
 *
 * **Backend enum — TBD.** Сейчас подтверждён только `thread_image` (картинки в чат).
 * Остальные значения (voice, document, video, …) появятся, когда бэк опубликует enum —
 * тогда расширить `THREAD_UPLOAD_TYPES` и маппинг `File` → upload type в widget-core.
 *
 * @see docs/API-KEYS.md — «Thread file upload»
 */
export const THREAD_UPLOAD_TYPES = {
  /** Images attached to thread chat (`type` в FormData). */
  IMAGE: 'thread_image',
} as const;

/** Upload types confirmed by backend today. */
export type ThreadUploadTypeKnown =
  (typeof THREAD_UPLOAD_TYPES)[keyof typeof THREAD_UPLOAD_TYPES];

/**
 * Upload `type` string. Use `ThreadUploadTypeKnown` where possible;
 * `string` until backend ships the full enum.
 */
export type ThreadUploadType = ThreadUploadTypeKnown | (string & {});

/** @deprecated Prefer `THREAD_UPLOAD_TYPES.IMAGE`. */
export const THREAD_IMAGE_UPLOAD_TYPE = THREAD_UPLOAD_TYPES.IMAGE;
